import i18next from 'i18next';
import '../../locales/i18n'; // i18n 초기화를 위해 import
import * as MenuIcons from '@app/components/QBIT/Header/components/MenuIcons';

// 메뉴를 함수로 변경하여 언어 변경 시 동적으로 텍스트를 업데이트할 수 있도록 함
export const getMenu = () => {
  const t = (key: string) => i18next.t(key);

  return [
    {
      title: t('buySellCrypto'),
      link: '/buysell-crypto',
      dropdown: true,
      subMenu: [
        {
          title: t('buySellCrypto'),
          link: '/buysell-crypto',
          description: t('depositCryptoSecurely'),
          icon: <MenuIcons.BuySellCryptoIcon />,
        },
      ],
    },

    {
      title: t('futures') + ' ' + t('markets') + ' ' + t('overview'),
      link: '/markets',
      dropdown: true,
      subMenu: [
        {
          title: t('markets') + ' ' + t('overview'),
          link: '/markets',
          description: t('marketOverview'),
          icon: <MenuIcons.MarketsOverviewIcon />,
        },
        {
          title: t('fearGreedIndex'),
          link: '/fear-greed-index',
          description: t('cryptoFearGreedIndex'),
          icon: <MenuIcons.FearGreedIndexIcon />,
        },
      ],
    },
    {
      title: t('futures'),
      link: '/trade/2',
      dropdown: true,
      subMenu: [
        {
          title: t('usdtPerpetuals'),
          link: '/trade/2',
          description: t('perpetualContracts'),
          icon: <MenuIcons.USDTPerpetualsIcon />,
        },
        {
          title: t('demoTrading'),
          link: '/demo-trade/2',
          description: t('demoTradingDescription'),
          icon: <MenuIcons.DemoTradingIcon />,
        },
        {
          title: t('copyTrading'),
          link: '/copy-trade',
          description: t('copyTradingDescription'),
          icon: <MenuIcons.MoreIcon />,
        },
        {
          title: t('tradingBots'),
          link: '/bot-trading',
          description: t('tradingBotsDescription'),
          icon: <MenuIcons.EventRewardsIcon />,
        },
      ],
    },
    {
      title: t('eventRewards'),
      link: '/reward',
      dropdown: false,
    },
    {
      title: t('affiliateProgram'),
      link: '/referral',
      dropdown: false,
    },
    {
      title: t('more'),
      link: '/about-us',
      dropdown: true,
      subMenu: [
        {
          title: t('aboutUs'),
          link: '/about-us',
          description: t('aboutUsDescription'),
          icon: <MenuIcons.AboutUsIcon />,
        },
        {
          title: t('institutional'),
          link: '/institutional',
          description: t('institutionalDescription'),
          icon: <MenuIcons.InstitutionalIcon />,
        },
        {
          title: t('termsAndConditions'),
          link: '/terms-and-conditions',
          description: t('termsAndConditionsDescription'),
          icon: <MenuIcons.TermsAndConditionsIcon />,
        },
        {
          title: t('guide'),
          link: '/guide',
          description: t('guideDescription'),
          icon: <MenuIcons.GuideIcon />,
        },
        {
          title: t('noticeCenter'),
          link: '/notice',
          description: t('noticeCenterDescription'),
          icon: <MenuIcons.NoticeCenterIcon />,
        },
      ],
    },
  ];
};

// Footer 메뉴도 함수로 변경
export const getFooterMenu = () => {
  const t = (key: string) => i18next.t(key);

  return [
    {
      title: t('products'),
      link: '/buysell-crypto',
      dropdown: true,
      subMenu: [
        {
          title: t('buySellCrypto'),
          link: '/buysell-crypto',
          description: t('depositCryptoSecurely'),
        },
        {
          title: t('usdtPerpetuals'),
          link: '/trade/2',
          description: t('perpetualContracts'),
        },
        {
          title: t('demoTrading'),
          link: '/demo-trade/2',
          description: t('demoTradingDescription'),
        },
        {
          title: t('copyTrading'),
          link: '/copy-trade',
          description: t('copyTradingDescription'),
        },
        {
          title: t('tradingBots'),
          link: '/bot-trading',
          description: t('tradingBotsDescription'),
        },
      ],
    },

    {
      title: t('markets'),
      link: '/markets',
      dropdown: true,
      subMenu: [
        {
          title: t('markets') + ' ' + t('overview'),
          link: '/markets',
          description: t('marketOverview'),
        },
        {
          title: t('fearGreedIndex'),
          link: '/fear-greed-index',
          description: t('cryptoFearGreedIndex'),
        },
      ],
    },

    {
      title: t('earnRewards'),
      link: '/reward',
      dropdown: true,
      subMenu: [
        {
          title: t('eventRewards'),
          link: '/reward',
        },
        {
          title: t('affiliateProgram'),
          link: '/referral',
        },
      ],
    },

    {
      title: t('company'),
      link: '/about-us',
      dropdown: true,
      subMenu: [
        {
          title: t('aboutUs'),
          link: '/about-us',
          description: t('aboutUsDescription'),
        },
        {
          title: t('institutional'),
          link: '/institutional',
          description: t('institutionalDescription'),
        },
      ],
    },

    {
      title: t('support'),
      link: '/terms-and-conditions',
      dropdown: true,
      subMenu: [
        {
          title: t('termsAndConditions'),
          link: '/terms-and-conditions',
          description: t('termsAndConditionsDescription'),
        },
        {
          title: t('CustomerService'),
          link: '/leverage-margin',
        },
      ],
    },
  ];
};

// 실시간 메뉴 업데이트를 위해 getter 함수만 export
export const Menu = getMenu();
export const FooterMenu = getFooterMenu();

// i18next 언어 변경 이벤트 리스너 추가
i18next.on('languageChanged', () => {
  // 언어 변경 시 Menu와 FooterMenu 업데이트
  Object.assign(Menu, getMenu());
  Object.assign(FooterMenu, getFooterMenu());
});
